module.exports = __webpack_public_path__ + "static/OP8-ee15a0f4ef12af4b9bf97033be97ef98.jpg";